import type { CreateWindowsCursorParams } from "../api/WindowsCursorsApi.types"

// Frames match by identity: a pixel buffer is made once per decode, and once per option change.
export const isSameUpload = (a: CreateWindowsCursorParams, b: CreateWindowsCursorParams) =>
  a.hotspotX === b.hotspotX &&
  a.hotspotY === b.hotspotY &&
  a.delayMs === b.delayMs &&
  a.alternate === b.alternate &&
  a.resampling === b.resampling &&
  a.frames.length === b.frames.length &&
  a.frames.every((pixels, index) => pixels === b.frames[index])
